import { Component, Inject, OnInit } from '@angular/core';
import { AclService } from '../../../services/acl.service';
import { RouteParamsService } from '../../../services/route-params.service';
import { forkJoin, Observable } from 'rxjs';
import { InstanceTypes } from '../../../models/instance-types';

@Component({
  selector: 'lib-preferences-home',
  templateUrl: './preferences-home.component.html',
  styleUrls: ['./preferences-home.component.css'],
  standalone: false
})
export class PreferencesHomeComponent implements OnInit {
  activeTab = 2;
  canManageUsers = false;
  hasNotificationPreferences = false;
  constructor(
    private aclService: AclService,
    private routeParamsService: RouteParamsService,
    @Inject('env') private env: any
  ) {}

  get isEmployeePortal() {
    return this.env.instanceType === InstanceTypes.EmployeePortal;
  }

  ngOnInit() {
    this.routeParamsService.getParam('client_code').subscribe(code => {
      const observables = [
        this.aclService.CurrentUserAccessCheck('CSR1', 'Client Portal Admin', code),
        this.aclService.CurrentUserIsInRole('Client Portal User', code),
        this.aclService.CurrentUserIsInRole('Client Portal Admin', code)
      ];
      forkJoin(observables).subscribe(result => {
        this.canManageUsers = result[0];
        this.hasNotificationPreferences = result[1] || result[2];
        if (!this.hasNotificationPreferences && this.canManageUsers) {
          this.activeTab = 3;
        }
        if (this.canManageUsers && this.hasNotificationPreferences) {
          this.routeParamsService.getQueryParam('active').subscribe(param => {
            if (param != null) {
              this.activeTab = parseInt(param);
            }
          });
        }
      });
    });
  }
}
